import request from '@/utils/sap-request'

// 合同查询
export const apiGetContractList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/contractsearch',
    method: 'POST',
    data
  })
}

// 合同审核
export const apiApprove = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/ct_batch_audit',
    method: 'POST',
    data
  })
}

// 合同详情查询
export const apiGetContractDetail = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/ctrctsearch001',
    method: 'POST',
    data
  })
}

// 获取财年
export const apiGetContractNy = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_contract_ny',
    method: 'POST',
    data
  })
}

// 获取合同名称
export const apiGetContractName = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_contract_mc',
    method: 'POST',
    data
  })
}

// 获取存货分类
export const apiGetContractChfl = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_chfl',
    method: 'POST',
    data
  })
}

// 获取渠道分类
export const apiGetContractQd = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_qudao',
    method: 'POST',
    data
  })
}

// 合同创建
export const apiContractCreate = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/contract_create',
    method: 'POST',
    data
  })
}

// 合同报表明细
export const apiContractDetailList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/ctractsearch01',
    method: 'POST',
    data
  })
}

// 合同批导
export const apiContractImport = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/contract_import',
    method: 'POST',
    data
  })
}

// 合同计划量调整量查询
export const apiContractPlanQuery = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_sales_plan',
    method: 'POST',
    data
  })
}
// 合同计划量调整量保存
export const apiContractPlanSave = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/save_htplan_adj',
    method: 'POST',
    data
  })
}
// 所有合同计划量调整量查询列表
export const apiContractPlanList = (data) => {
  return request({
    url: 'sap/bc/ztpm/to_new_crm/transdata/get_htplan_adj',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/sap/contract.js